import logo from './logo.svg';
import './App.css';

import PlateDetection from './PlateDetection';

function App() {
  return (
    <div className="App">      
      <header className="App-header">
        <PlateDetection/>
      </header>
    </div>
  );
}

export default App;
